import React, { createContext, useContext, useState, useEffect } from 'react';

const STORAGE_KEY = 'payzen_layout_variant';

const LayoutVariantContext = createContext(null);

export const useLayoutVariant = () => {
  const context = useContext(LayoutVariantContext);
  if (!context) {
    throw new Error('useLayoutVariant must be used within LayoutVariantProvider');
  }
  return context;
};

export const LayoutVariantProvider = ({ children }) => {
  const [variant, setVariantState] = useState(() => {
    try {
      return localStorage.getItem(STORAGE_KEY) || 'reference';
    } catch {
      return 'reference';
    }
  });

  useEffect(() => {
    try {
      localStorage.setItem(STORAGE_KEY, variant);
    } catch {
      // ignore
    }
  }, [variant]);

  const setVariant = (value) => {
    setVariantState(value === 'reference' ? 'reference' : 'classic');
  };

  const toggleVariant = () => {
    setVariantState((prev) => (prev === 'classic' ? 'reference' : 'classic'));
  };

  const value = {
    variant,
    isReference: variant === 'reference',
    isClassic: variant === 'classic',
    setVariant,
    toggleVariant,
  };

  return (
    <LayoutVariantContext.Provider value={value}>
      {children}
    </LayoutVariantContext.Provider>
  );
};
